import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
  getJobCategories, getPriorities, getQualifications,
} from '../redux/reduxActions/actions';
import Menu from '../components/componentsUI/Menu';
import {
  getFunnelStatus,
  getFunnelType,
  getResponsible,
  getWorkTech,
  getWorkType,
  getProposalType,
} from '../redux/reduxActions/leadActions';
import { getEventTypes } from '../redux/reduxActions/planActions';

function Dashboard(props) {
  const { children } = props;
  useEffect(() => {
    if (!localStorage.getItem('token')) {
      window.location.href = '/login';
    } else {
      props.getPriorities();
      props.getJobCategories();
      props.getQualifications();
      props.getFunnelType();
      props.getFunnelStatus();
      props.getWorkType();
      props.getWorkTech();
      props.getResponsible();
      props.getProposalType();
      props.getEventTypes();
    }
  }, []);
  return (
    <div>
      <Menu />
      {children}
    </div>
  );
}
export default connect((store) => store,
  {
    getPriorities,
    getJobCategories,
    getQualifications,
	  getFunnelType,
	  getFunnelStatus,
	  getWorkType,
	  getWorkTech,
	  getResponsible,
	  getProposalType,
	  getEventTypes,
  })(Dashboard);
